import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import { CATEGORY_COLOR_MAP, CATEGORY_BACKGROUND_COLOR_MAP, CATEGORY_ANNOTATION_MAP } from '@/constant/Categorise.constant'

export default (CategoriseConfigView) => Vue.component('CategoriseConfigController', {
  computed: {
    ...mapGetters({
      categories: 'categorise/slideActiveCategories',
      canUseGenerateOptions: 'featureToggles/canUseGenerateOptions',
    }),
  },
  methods: {
    ...mapActions({
      updateCategoriesAction: 'categorise/updateCategoriesAction',
    }),
    async onAddCategories(category) {
      await this.updateCategoriesAction([
        ...this.categories,
        category,
      ])
    },
    async onRemoveCategories(id) {
      const categories = this.categories.filter((category) => category.id !== id)
      await this.updateCategoriesAction(categories)
    },
    async onUpdateCategories(updatedCategory) {
      const categories = this.categories
        .map((category) => (category.id === updatedCategory.id ? updatedCategory : category))
      await this.updateCategoriesAction(categories)
    },
  },
  render(createElement) {
    return createElement(CategoriseConfigView, {
      props: {
        categories: this.categories,
        categoryColorMap: CATEGORY_COLOR_MAP,
        categoryBackgroundColorMap: CATEGORY_BACKGROUND_COLOR_MAP,
        categoryAnnotationMap: CATEGORY_ANNOTATION_MAP,
        onAddCategories: this.onAddCategories,
        onRemoveCategories: this.onRemoveCategories,
        onUpdateCategories: this.onUpdateCategories,
        canUseGenerateOptions: this.canUseGenerateOptions,
      },
    })
  },
})
